<template>
  <MapMarker
    v-if="shuttle"
    :coordinates="[shuttle.latitude, shuttle.longitude]"
    icon="fa-bus"
    :popup-content="`Shuttle ${getName(shuttle.id)}`"
    slide
    @click="openShuttleTracker()"
  />
</template>

<script>
import MapMarker from '@/components/map/MapMarker'
import ShuttleService from '@/services/ShuttleService'

export default {
  name: 'CampusShuttle',
  components: {
    MapMarker
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      shuttle: null,
      interval: -1,
      refreshRate: 7500
    }
  },
  computed: {
  },
  watch: {
  },
  async created () {
    this.loadShuttle()
    this.interval = setInterval(this.loadShuttle, this.refreshRate)
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  methods: {
    async loadShuttle () {
      const response = await ShuttleService.getShuttle(this.id)
      this.shuttle = response
    },
    getName (id) {
      return id.replace(/\D/g, '')
    },
    openShuttleTracker () {
      window.open('https://bustracker.stthomas.edu/', '_blank')
    }
  }
}
</script>
